import React, { useState } from "react";
import SidebarConfig from "./SidebarConfig"; // Importando a Sidebar

import "./ConfigPage.css"; // Importando os estilos


const ConfigPage = () => {
  const [sidebarVisivel] = useState(false);

  return (
    <div className="config-container">
      {/* Sidebar */}
      <SidebarConfig className={sidebarVisivel ? "show" : ""} />
      
     
    </div>
  );
};

export default ConfigPage;
